export class Environment {
  production = false;
  alias: string;
  tenantId: string;
  pendoApiKey: string;
  entitlements = false;
  enableRouterTracing = false;
  useProxy = false;

  constructor(init?: Partial<Environment>) {
    Object.assign(this, init);
  }
}
